import type { ManageAPI } from "~/manage-api/types";
export const displayFloor = (store: ManageAPI.Store | undefined, T) => {
    if (!store) return ""
    let floor = store?.floor?.description || '';
    if (store?.secondaryFloor) {
        floor += " " + T`and` + " " + store.secondaryFloor.description;
    }
    return floor;
};